// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SubProductOfferingDetailService = {};

SubProductOfferingDetailService.postSubProductOfferingDetail = function (data) {
  // console.log("🚀 ~ SubProductOfferingDetailServicedata:", data);
  return lossClient({
    url: "/SubProductOfferingDetail/add",
    method: "post",
    data: data,
  });
};

SubProductOfferingDetailService.putSubProductOfferingSliceDetail = function (
  data
) {
  // console.log("🚀 ~ SubProductOfferingDetailServicedata:", data);
  return lossClient({
    url: "/SubProductOfferingDetail/edit",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data.data,
  });
};
SubProductOfferingDetailService.getsubproductOfferingDetail = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SubProductOfferingDetail/search?pageSize= " +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

SubProductOfferingDetailService.getsubproductOfferingDetailSerch = function (
  userInput
) {
  // console.log("🚀 ~ getsubproductOfferingDetailSerchuserInput:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SubProductOfferingDetail/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

SubProductOfferingDetailService.getsubproductOfferingDetailApproval = function (
  userInput
) {
  // console.log("🚀 ~ getsubproductOfferingDetailApprovaluserInput:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // return fetch({
  //   url: "/SubProductOfferingDetail/approvalItems?pageSize=10&pageIndex=0&code=KKBCFFC6",
  //   method: "get",
  // });
  return lossClient({
    url:
      "/SubProductOfferingDetail/approvalItems?pageSize= " +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

SubProductOfferingDetailService.subproductOfferingDetailApproval = function (
  data
) {
  // console.log("🚀 ~ datasubproductOfferingDetailApproval:", data);
  return lossClient({
    url: "/SubProductOfferingDetail/approve",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data.data,
  });
};

SubProductOfferingDetailService.productOfferingDetailReturn = function (data) {
  // console.log("🚀 ~ dataproductOfferingDetailReturn:", data);
  return lossClient({
    url: "/SubProductOfferingDetail/return",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data.data,
  });
};

SubProductOfferingDetailService.ProductOfferingDetailReject = function (data) {
  return lossClient({
    url: "/SubProductOfferingDetail/reject",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data.data,
  });
};

SubProductOfferingDetailService.ProductOfferingDetailRequest = function (data) {
  return lossClient({
    url: "/SubProductOfferingDetail/request",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data.data,
  });
};

SubProductOfferingDetailService.deleteProductOfferingDeleteCharges = function (
  data
) {
  // console.log("🚀 ~ deleteProductOfferingDeleteChargesdata:", data);
  return lossClient({
    url: "/SubProductOfferingDetail/delete",
    method: "delete",
    headers: {
      "x-RequestId": data.id,
    },
    data: data.data,
  });
};

SubProductOfferingDetailService.uploadProductOfferingDetail = function (data) {
  // console.log("🚀 ~uploadProductFeeCharges data:", data);

  return lossClient({
    url: `/SubProductOfferingDetail/uploadOfferingDetail`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default SubProductOfferingDetailService;
